import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPremiumDiamondBig = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5619_10230)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.8377 24.497C49.8471 24.4501 49.8377 24.4126 49.8377 24.3657C49.8377 24.3001 49.8283 24.2438 49.8096 24.1782C49.8002 24.1407 49.7908 24.1032 49.7814 24.0657C49.7721 24.0563 49.7721 24.0376 49.7721 24.0282C49.7346 23.9438 49.6877 23.8688 49.6221 23.8032L42.4783 15.8532C42.3096 15.6657 42.0564 15.5532 41.8033 15.5532H18.2064C17.9439 15.5532 17.7002 15.6657 17.5314 15.8532L10.3971 23.7938C10.3314 23.8688 10.2752 23.9438 10.2283 24.0376C10.2189 24.0563 10.2189 24.0751 10.2096 24.0938C10.2002 24.1126 10.2002 24.1313 10.1908 24.1501C10.1627 24.2345 10.1533 24.3282 10.1533 24.4126V24.4876C10.1627 24.5907 10.1814 24.6938 10.2283 24.797C10.2283 24.8063 10.2377 24.8063 10.2377 24.8157C10.2752 24.8907 10.3127 24.9563 10.3689 25.022L29.3064 46.1251C29.3252 46.1532 29.3627 46.1626 29.3814 46.1813C29.4283 46.2282 29.4846 46.2657 29.5408 46.2938C29.5877 46.322 29.6252 46.3407 29.6721 46.3595C29.7471 46.3876 29.8221 46.4063 29.9064 46.4063C29.9346 46.4063 29.9627 46.4251 29.9908 46.4251C30.0096 46.4251 30.0377 46.4157 30.0564 46.4157C30.1502 46.4063 30.2346 46.3876 30.3189 46.3595C30.3564 46.3407 30.3939 46.322 30.4221 46.3032C30.4877 46.2657 30.5533 46.2188 30.6096 46.1626C30.6283 46.1438 30.6471 46.1438 30.6658 46.1251L49.5377 25.097C49.5377 25.097 49.5377 25.097 49.5377 25.0876L49.5939 25.022C49.6314 24.9845 49.6502 24.9376 49.6783 24.8907C49.7158 24.8345 49.7439 24.7688 49.7721 24.7032C49.8096 24.6188 49.8283 24.5626 49.8377 24.497ZM46.9033 23.4845H37.8096L35.0533 17.3626H41.4002L46.9033 23.4845ZM24.0377 25.3032H35.9439L30.0002 42.6845L24.0377 25.3032ZM24.1783 23.4845L26.9346 17.3626H33.0564L35.8127 23.4845H24.1783ZM18.6096 17.3532H24.9471L22.1908 23.4751H13.1064L18.6096 17.3532ZM22.1158 25.3032L27.6939 41.5688L13.0971 25.3032H22.1158ZM32.3064 41.5595L37.8752 25.2938H46.9033L32.3064 41.5595Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0002 5.30625C30.5064 5.30625 30.9096 4.90313 30.9096 4.39688V0.909375C30.9096 0.403125 30.4971 0 30.0002 0C29.4939 0 29.0908 0.403125 29.0908 0.909375V4.39688C29.0908 4.89375 29.4939 5.30625 30.0002 5.30625Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.4064 8.27796C16.5751 8.56859 16.8845 8.72796 17.1939 8.72796C17.3439 8.72796 17.5033 8.69046 17.6439 8.60609C18.0751 8.35296 18.2251 7.79984 17.9814 7.36859L16.2376 4.34984C15.9845 3.91859 15.4314 3.76859 15.0001 4.02171C14.5689 4.27484 14.4189 4.82796 14.6626 5.25921L16.4064 8.27796Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.34976 16.2468L7.36851 17.9905C7.50913 18.0749 7.66851 18.1124 7.81851 18.1124C8.13726 18.1124 8.43726 17.953 8.60601 17.6624C8.85913 17.2311 8.70913 16.6686 8.26851 16.4249L5.24976 14.6811C4.81851 14.4186 4.26538 14.5686 4.01226 14.9999C3.76851 15.4405 3.91851 15.9936 4.34976 16.2468Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.30625 30.0002C5.30625 29.4939 4.90313 29.0908 4.39688 29.0908H0.909375C0.403125 29.0908 0 29.5033 0 30.0002C0 30.4971 0.403125 30.9096 0.909375 30.9096H4.39688C4.89375 30.9096 5.30625 30.5064 5.30625 30.0002Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.36859 42.0188L4.34984 43.7625C3.91859 44.0157 3.76859 44.5688 4.02171 45C4.19046 45.2907 4.49984 45.45 4.80921 45.45C4.95921 45.45 5.11859 45.4125 5.25921 45.3282L8.27796 43.5844C8.70921 43.3313 8.85921 42.7782 8.61546 42.3469C8.36234 41.9157 7.80921 41.7657 7.36859 42.0188Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.653 51.3939C17.2124 51.1408 16.6593 51.2908 16.4155 51.7314L14.6718 54.7502C14.4186 55.1814 14.5686 55.7439 15.0093 55.9877C15.1499 56.0721 15.3093 56.1096 15.4593 56.1096C15.778 56.1096 16.078 55.9502 16.2468 55.6596L17.9905 52.6408C18.2343 52.2002 18.0936 51.6377 17.653 51.3939Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0002 54.6938C29.4939 54.6938 29.0908 55.097 29.0908 55.6032V59.0907C29.0908 59.597 29.4939 60.0001 30.0002 60.0001C30.5064 60.0001 30.9096 59.597 30.9096 59.0907V55.6032C30.9096 55.1063 30.5064 54.6938 30.0002 54.6938Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.5941 51.7218C43.341 51.2906 42.7878 51.1406 42.3566 51.3843C41.9253 51.6375 41.7753 52.1906 42.0191 52.6218L43.7628 55.6406C43.9316 55.9312 44.241 56.0906 44.5503 56.0906C44.7003 56.0906 44.8597 56.0531 45.0003 55.9687C45.4316 55.7156 45.5816 55.1625 45.3378 54.7312L43.5941 51.7218Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.6497 43.7529L52.6309 42.0092C52.1903 41.756 51.6372 41.906 51.3934 42.3467C51.1403 42.7779 51.2903 43.3404 51.7309 43.5842L54.7497 45.3279C54.8903 45.4123 55.0497 45.4498 55.1997 45.4498C55.5184 45.4498 55.8184 45.2904 55.9872 44.9998C56.2309 44.5592 56.0809 44.006 55.6497 43.7529Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.0902 29.0908H55.6027C55.0965 29.0908 54.6934 29.4939 54.6934 30.0002C54.6934 30.5064 55.0965 30.9096 55.6027 30.9096H59.0902C59.5965 30.9096 59.9996 30.5064 59.9996 30.0002C59.9996 29.4939 59.5965 29.0908 59.0902 29.0908Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.1718 18.1033C52.3218 18.1033 52.4812 18.0658 52.6218 17.9814L55.6406 16.2376C56.0718 15.9845 56.2218 15.4314 55.9781 15.0001C55.725 14.5689 55.1718 14.4189 54.7406 14.6626L51.7218 16.4064C51.2906 16.6595 51.1406 17.2126 51.3843 17.6439C51.5531 17.9345 51.8625 18.1033 52.1718 18.1033Z",
					fill: "#1A5455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.3469 8.60624C42.4875 8.69061 42.6469 8.72811 42.7969 8.72811C43.1156 8.72811 43.4156 8.56874 43.5844 8.27811L45.3281 5.25936C45.5813 4.82811 45.4313 4.26561 44.9906 4.02186C44.55 3.76874 43.9969 3.91874 43.7531 4.35936L42.0094 7.37811C41.7656 7.79999 41.9063 8.36249 42.3469 8.60624Z",
					fill: "#1A5455"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5619_10230",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPremiumDiamondBig);
export default ForwardRef;
